import IconData from './IconsData';

export default IconData;
